<template>
    <div class="nav-wrap">
        <mt-navbar v-model="selected" class="flex">
            <!--<div class="flex1"></div>-->
            <div class="flex1">
                <mt-tab-item id="1" :class="selected==1?'is-selected':''">零售佣金 {{ totalIncomeRetail / 100 }}</mt-tab-item>
            </div>
            <!-- <div class="flex1"></div>-->
            <div class="flex1">
                <mt-tab-item id="2" :class="selected==2?'is-selected':''">团队佣金 {{ totalIncomeTeam / 100 }} </mt-tab-item>
            </div>
            <!--<div class="flex1"></div>-->

        </mt-navbar>
        <hr />
        <mt-tab-container v-model="selected">
            <mt-tab-container-item id="1">
                <!--<p class="blacl_font">零售总佣金：{{ totalIncomeRetail / 100 }}</p>-->
                <ul v-if="incomeRetail.list.length !== 0">
                    <li class="flex nav-title">
                        <div class="flex3 skyBlue">购买者</div>
                        <div class="flex2 waterBlue">结算时间</div>
                        <div class="flex2 skyBlue">订单价格￥</div>
                        <div class="flex2 waterBlue">奖励￥</div>
                    </li>
                    <li class="flex nav-title" v-for="(item, index) in incomeRetail.list" :key="index">
                        <div class="flex3 left">
                            <img :src="item.user.headUrl" class="avatar">
                            <div class="user-info">
                                <span> {{item.user.nick}}</span>
                                <span> {{item.user.memberNo}}</span>
                            </div>
                        </div>
                        <div class="flex2">{{ TimeFormat(item.createDate) }}</div>
                        <div class="flex2">{{ (item.orderPrice / 100).toFixed(2) }}
                        </div>
                        <div class="flex2"><span v-if="item.level" :style="random(item.level)">
                                {{ item.level }}
                            </span> {{ (item.incomePrice /100).toFixed(2) }}</div>
                    </li>
                </ul>
                <div v-if="incomeRetail.list.length === 0" class="empty">
                    <img src="../../../static/img/empty.svg" alt="">
                    <p class='nodata'>暂无更多信息</p>
                </div>
            </mt-tab-container-item>
            <mt-tab-container-item id="2">
                <!--<p class="blacl_font">团队总佣金：{{ totalIncomeTeam / 100 }}</p>-->
                <ul v-if="incomeTeam.list.length !== 0">
                    <li class="flex nav-title">
                        <div class="flex3 skyBlue">购买者</div>
                        <div class="flex2 waterBlue">时间</div>
                        <div class="flex2 skyBlue">订单价格￥</div>
                        <div class="flex2 waterBlue">工资￥</div>
                    </li>
                    <li class="flex nav-title" v-for="(item, index) in incomeTeam.list" :key="index">
                        <div class="flex3 left">
                            <img :src="item.user.headUrl" class="avatar">
                            <div class="user-info">
                                <span> {{item.user.nick}}</span>
                                <span> {{item.user.memberNo}}</span>
                            </div>
                        </div>
                        <div class="flex1">{{ TimeFormat(item.createDate) }}</div>
                        <div class="flex2">{{ (item.orderPrice / 100).toFixed(2) }}</div>
                        <div class="flex2"><span v-if="item.level" :style="random(item.level)">
                                {{ item.level }}
                            </span> {{ (item.incomePrice / 100).toFixed(2) }}</div>
                    </li>
                </ul>
                <div v-if="incomeTeam.list.length === 0" class="empty">
                    <img src="../../../static/img/empty.svg" alt="">
                    <p class='nodata'>暂无更多信息</p>
                </div>
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>

<script>
import { formatDate } from '../../utils/utils';

export default {
  props: ['incomeRetail', 'totalIncomeRetail', 'incomeTeam', 'totalIncomeTeam'],
  //watch: {
  //    selected: function(newValue) {
  //        if (newValue === '1') this.$store.dispatch('user/getIncomeRetail')
  //        if (newValue === '2') this.$store.dispatch('user/getIncomeTeam')
  //    }
  //},
  name: 'TableDetail',
  methods: {
    random: function(level) {
      // const color = "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);
      const color = this.colorList[(level % 7) - 1];
      return {
        color: color,
        border: '1px solid',
        borderColor: color,
        width: '.1rem',
        height: '.1rem',
        display: 'inline-block',
        borderRadius: '50%',
        lineHeight: '.1rem',
        textAlign: 'center',
      };
    },
    TimeFormat(value) {
      let d = new Date();
      d.setTime(value);
      return formatDate('MM/dd HH:mm', d);
    },
  },
  data() {
    return {
      selected: '1',
      colorList: [
        '#707070',
        '#007FE1',
        '#1300BA',
        '#009279',
        '#00BBE2',
        '#7C0085',
        '#E5B000',
        '#E200DA',
        '#FF0000',
      ],
    };
  },
  created() {
    // this.TimeFormat = formateMonth;
    // 获取初始数据
    this.$store.dispatch('user/getIncomeRetail');
    this.$store.dispatch('user/getIncomeTeam');
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex1 {
  white-space: nowrap;
}
.left {
  padding-left: 0.05rem;
  text-align: left;
}
.nav-wrap {
  height: 0.52rem;
  color: #000;
}
.mint-tab-item {
  color: #000000;
  font-weight: bolder;
}
.is-selected {
  color: #009688 !important;
}
.mint-navbar .mint-tab-item.is-selected {
  border-bottom: 4px solid #009688;
  color: #009688 !important;
  height: 0.07rem;
  margin-bottom: -3px;
  border-radius: 3px;
}
hr {
  margin-top: -0.04rem;
}
.nav-title {
  margin-top: 0.1rem;
  height: 0.32rem;
  line-height: 0.32rem;
}
ul {
  padding-left: 0px;
  text-align: center;
}
.avatar {
  position: relative;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  top: 0.04rem;
}
.user-info {
  display: inline-block;
  margin-left: 0.06rem;
  line-height: 1;
  vertical-align: top;
  width: 0.8rem;
}
.user-info > span {
  display: block;
  line-height: 0.15rem;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.empty {
  text-align: center;
  margin-top: 1.06rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userProfitElement/TableDetail.vue